module.exports = __webpack_public_path__ + "static/media/img3-2.43074469.png";